import React, { memo } from 'react';
import { RouteFC } from 'util/routeTypes';
import { Matryoshka } from '@clover-util/matryoshka';
import { CartBody } from './CartBody';
import { SubmitOrderProvider, useSubmitOrder } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { CheckoutValidityProvider } from 'routes/Checkout/context/CheckoutValidity';
import { OrderDetailsProvider } from 'routes/Checkout/context/OrderDetails';
import { OrderResponseSummaryProvider } from 'routes/Checkout/context/OrderResponseSummary';
import { ApplePayProvider } from './ApplePay/ApplePay';
import { OverlaySpinner } from './Spinner';
import { OrderHistoryProvider } from 'hooks/context/OrderHistory';

const CART_PROVIDERS = [
  CheckoutValidityProvider,
  OrderDetailsProvider,
  OrderResponseSummaryProvider,
  ApplePayProvider,
  SubmitOrderProvider,
  OrderHistoryProvider
];

const Blocker: React.FC = () => {
  const { isOrderProcessing } = useSubmitOrder();

  if (!isOrderProcessing) return null;

  return <OverlaySpinner />;
};

export const CartPage: RouteFC<{ children?: never, props: any }> = memo(function CartPage({ ...props }) {
  return (
    <Matryoshka wrappers={CART_PROVIDERS}>
      <CartBody {...props} />
      <Blocker />
    </Matryoshka>
  );
});
